import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from 'react-icons/ai';
import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';
import {
    MdOutlineEdit,
    MdOutlineCheckBoxOutlineBlank,
    MdOutlineCheckBox,
    MdArrowForwardIos,
    MdArrowBackIos
} from 'react-icons/md';
import Spinner from 'assets/gif/dots.gif';
import axios from 'config/axios';
import { useAuthContext } from 'context/AuthContext';
import Table from 'components/Table';
import TextInput from 'components/TextInput';
import Popup from 'components/Popup';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

type AssignmentsProps = {
    studs: any[];
    assignments: any[];
    testType: string;
    assignmentType: string;
    setAssignments: ({}) => void;
    updateAssignments: boolean;
};

function Assignments({
    studs,
    assignments,
    testType,
    assignmentType,
    setAssignments,
    updateAssignments
}: AssignmentsProps) {
    const [assignmentIndex, setAssignmentIndex] = useState(null);
    const [students, setStudents] = useState([]);
    const [studentsLoading, setStudentsLoading] = useState(false);
    const [search, setSearch] = useState('');

    const { classId } = useParams();

    const navigate = useNavigate();
    const { user } = useAuthContext();

    const assignAssignment = (questionSetId: string) => {
        axios.post('tutors/classes/assignment/assign/', {
            classId: classId,
            questionSetId: questionSetId
        })
        .then(res => {
            setAssignments(res.data.questionSets);
        })
        .catch(error => {
            console.log(error);
        });
    }

    const removeAssignment = (questionSetId: string) => {
        axios.post('tutors/classes/assignment/remove/', {
            classId: classId,
            questionSetId: questionSetId
        })
        .then(res => {
            setAssignments(res.data.questionSets);
        })
        .catch(error => {
            console.log(error);
        });
    }

    const hideAssignmentReview = (questionSetId: string) => {
        axios.post('/tutors/classes/assignment/hideReview/', {
                classId: classId,
                questionSetId: questionSetId
            })
            .then(res => {
                let newAssignments = [ ...assignments ];
                const assignmentIndex = newAssignments.findIndex(assignment => assignment.questionSetId === questionSetId);

                newAssignments[assignmentIndex].questionSetReview = false;
                setAssignments(newAssignments);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const showAssignmentReview = (questionSetId: string) => {
        axios.post('/tutors/classes/assignment/showReview/', {
                classId: classId,
                questionSetId: questionSetId
            })
            .then(res => {
                let newAssignments = [ ...assignments ];
                const assignmentIndex = newAssignments.findIndex(assignment => assignment.questionSetId === questionSetId);

                newAssignments[assignmentIndex].questionSetReview = true;
                setAssignments(newAssignments);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const assigned = assignments.filter(assignment => (
        assignment.assignDate &&
        assignment.type === testType
    )).sort((a, b) => (
        new Date(b.assignDate).getTime() - new Date(a.assignDate).getTime()
    ));

    const newAssignments = assignments.filter(assignment => (
        !assignment.assignDate &&
        assignment.type === testType
    ));

    useEffect(() => {
        if (assigned[assignmentIndex]) {
            setStudentsLoading(true);
            setStudents([]);
            axios.get(`tutors/classes/${classId}/assignments/${assigned[assignmentIndex].assignmentId}/`)
                .then(res => {
                    setStudents(res.data.students);
                    setStudentsLoading(false);
                })
                .catch(error => {
                    console.log(error);
                    setStudentsLoading(false);
                });
        }
    }, [assignmentIndex]);
    
    return (
        <div className='class-tests'>
            {updateAssignments
            ?   <>
                    <Table
                        key={`remove_${testType}`}
                        className='class-tests__table'
                        header={['', 'Name']}
                        rows={assigned.filter(assignment => assignmentType === 'Preset' ? assignment.preset : !assignment.preset).map(assignmment => ([
                            <p className='class-tests__remove'>Remove</p>,
                            <span className="class-tests__testsContent">
                                {assignmment.name}
                            </span>,
                        ]))}
                        onSelectCell={assigned.filter(assignment => assignmentType === 'Preset' ? assignment.preset : !assignment.preset).map(assignment => ([
                            () => removeAssignment(assignment.questionSetId),
                            null,
                            null
                        ]))}
                    />
                    <AiOutlineDoubleLeft className='class-tests__arrow' />
                    <Table
                        key={`assign ${testType}`}
                        className='class-tests__table'
                        header={['', 'Name']}
                        rows={newAssignments.filter(assignment => assignmentType === 'Preset' ? assignment.preset : !assignment.preset).map(assignment => ([
                            'Assign',
                            <span className="class-tests__testsContent">
                                {assignment.name}
                            </span>,
                        ]))}
                        onSelectCell={newAssignments.filter(assignment => assignmentType === 'Preset' ? assignment.preset : !assignment.preset).map(assignment => ([
                            () => assignAssignment(assignment.questionSetId),
                            null,
                            null
                        ]))}
                    />
                </>
            :   <div className='class-tests__tests'>
                    <Table
                        className='class-tests__table'
                        header={assignmentIndex === null ? [
                            'Name',
                            'Section',
                            '# Assigned',
                            // '# Taken',
                            'Assigned Date',
                            ... user.customizations.find(customization => customization === 'Hide Report') ? ['Show/Hide Report'] : [],
                            studs.length > 0? 'Report': '-'
                        ] : [
                            '',
                            'Name'
                        ]}
                        // columnTypes={['number', 'number', 'date', 'string']}
                        rows={assigned.map(assignment => (assignmentIndex === null ? [
                            assignment.name,
                            assignment.subject,
                            assignment.numAssigned,
                            // test.numTaken,
                            new Date(assignment.assignDate).toLocaleDateString(),
                            ... user.customizations.find(customization => customization === 'Hide Report')
                                ? [assignment.questionSetReview
                                    ? <IoEyeOutline className='class-tests__show' />
                                    : <IoEyeOffOutline className='class-tests__hide' />
                                ] : [],
                            'Report'
                        ] : [
                            assignment.name
                        ]))}
                        onSelectCell={assigned.map((assignment, t) => (assignmentIndex === null ? [
                            () => navigate(`/assignments/${assignment.questionSetId}`),
                            null,
                            null,
                            null,
                            // null,
                            ... user.customizations.find(customization => customization === 'Hide Report')
                                ? [assignment.questionSetReview
                                    ? () => hideAssignmentReview(assignment.questionSetId)
                                    : () => showAssignmentReview(assignment.questionSetId)
                                ] : [],
                            () => navigate(`/classes/${classId}/assignment/${assignment.questionSetId}`),    
                        ] : [
                            null
                        ]))}
                        // onSelectRow={tests.filter(test => test.assignDate).sort((a, b) => (
                        //     new Date(b.assignDate).getTime() - new Date(a.assignDate).getTime()
                        // )).map((test, t) => (
                        //     () => assignmentIndex === t ? setassignmentIndex(null) : setassignmentIndex(t)
                        // ))}
                        // rowsSelected={tests.filter(test => test.assignDate).sort((a, b) => (
                        //     new Date(b.assignDate).getTime() - new Date(a.assignDate).getTime()
                        // )).map((test, t) => (
                        //     assignmentIndex === t
                        // ))}
                    />
                </div>
            }
        </div>
    );
}

export default Assignments;